var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("article", { staticClass: "template-page-tile" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "is-flex is-justify-content-space-between" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("Tags")]),
              _c(
                "span",
                {
                  staticClass: "button is-small is-primary is-light tooltip",
                  class: `is-light-btn-${_vm.$theme.name}`,
                  attrs: { "data-tooltip": "Manage Tags" },
                  on: { click: _vm.toggleManageTagsModal },
                },
                [_c("i", { staticClass: "icon mdi mdi-plus mdi-24px" })]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "tags-scroll-container" },
            _vm._l(_vm.tags, function (tag) {
              return _c(
                "div",
                {
                  key: tag.tagID,
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      return _vm.toggleTag(tag)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "is-flex is-align-items-center p-2" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "tag-short mr-2",
                          style: {
                            backgroundColor: tag.colorHex,
                            color: _vm.getTextColor(tag.colorHex),
                          },
                        },
                        [_vm._v(_vm._s(tag.shortTag))]
                      ),
                      _c("span", { staticClass: "mr-auto" }, [
                        _vm._v(_vm._s(tag.tagName)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-curve p-smooth p-bigger m-0 ml-2",
                        },
                        [
                          _c("input", {
                            staticStyle: { cursor: "pointer" },
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.selectedTags.includes(tag.tagID),
                            },
                            on: {
                              change: function ($event) {
                                $event.stopPropagation()
                                return _vm.toggleTag(tag)
                              },
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "state p-primary",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleTag(tag)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "icon mdi mdi-check" }),
                              _c("label"),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("hr", { staticClass: "m-0" }),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      true
        ? _c("manage-tags-modal", {
            attrs: {
              active: _vm.showManageTagsModal,
              tags: _vm.tags,
              "tag-category-id": _vm.tagCategoryId,
            },
            on: {
              close: function ($event) {
                _vm.showManageTagsModal = false
              },
              save: _vm.handleSaveTags,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }